const _scrollTo = (() => {
    const getFirstFocusableIn = (container: HTMLElement) => {
        if (!container) return null;

        return container.querySelector<HTMLElement>("a[href], button:not([disabled]), input:not([disabled]):not([type='hidden']), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex='-1']), [contenteditable='true']");
    };

    const focusMainContent = (hashTarget: string) => {
        const target = document.querySelector<HTMLElement>(hashTarget);
        if (!target) return;

        const firstFocusable = getFirstFocusableIn(target);
        if (firstFocusable) {
            firstFocusable.focus();
            return;
        }

        const hadTabindex = target.hasAttribute("tabindex");
        if (!hadTabindex) target.setAttribute("tabindex", "-1");
        target.focus();
    };

    const scroll = (to: string | undefined) => {
        if (!to) return;

        const toEl = document.querySelector<HTMLElement>(to);
        const header = document.querySelector<HTMLElement>("header");

        if (toEl) {
            setTimeout(() => {
                requestAnimationFrame(() => {
                    const scrollDestination = (toEl.offsetTop ?? 0) - (header?.clientHeight ?? 0);
                    window.scroll({
                        top: scrollDestination,
                        behavior: window.matchMedia("(prefers-reduced-motion: reduce)").matches ? "auto" : "smooth",
                    });
                });
            }, 100);
        }
    };

    const init = () => {
        const header = document.querySelector<HTMLElement>("header");
        document.querySelectorAll("[href^='#'],[data-scrollto]").forEach((el) => {
            el.addEventListener("click", (e) => {
                const $this = e.currentTarget as HTMLElement;
                const href = $this.attributes.getNamedItem("href")?.value;

                e.preventDefault();

                if (href?.startsWith("#")) {
                    scroll(href);
                    setTimeout(() => {
                        focusMainContent(href);
                    }, 150);
                    return;
                }

                if ($this.attributes.getNamedItem("data-scrollto-nostate") !== undefined) {
                    scroll(href);
                    return;
                }
                scroll(href);
            });
        });
        try {
            window.addEventListener("load", () => {
                if (window.location.hash.indexOf("/") >= 0) return;
                if (window.location.hash) {
                    scroll(window.location.hash);
                }
                if (window.location.search) {
                    if (window.location.search.indexOf("p=") > 0) {
                        const goto = window.location.search.substring(window.location.search.indexOf("p=") + 2);
                        scroll("#" + goto);
                    }
                }
            });
        } catch (err) {}
    };

    return {
        init: init,
    };
})();

export default _scrollTo;
